import { Helper, Status } from '../../../../../classes/helper'
import { useMontage } from '../../../../../context/montage.context'
import { useStateEgo } from '../../../../../hooks/state'
import { WindowsFrontBars } from './bar/WindowsFrontBars'
import { WindowsFrontGlass } from './glass/WindowsFrontGlass'
import { WindowsFrontTie } from './tie/WindowsFrontTie'

export const WindowsFront = (): JSX.Element | null => {
  const { measure, sidewall,ego } = useMontage()
  let offset = 8

  if (Status.sidewallFront(sidewall)) return null
  if (Status.sidewallDoorFront(sidewall)) offset = 4

  return (
    <group position={[0, 0, Helper.convertToMeter(offset)]}>
      <group>
        {[...Array(measure.logsFrontTotal)].map((_, index) => {
          return <WindowsFrontBars key={index} positionX={index} />
        })}
      </group>

      <group>
        {[...Array(measure.windowsFrontTotal)].map((_, index) => {
          return (
            <group key={index}>
              <WindowsFrontGlass positionX={index} />
              <WindowsFrontTie />
            </group>
          )
        })}
      </group>
    </group>
  )
}
